import React, { useState } from 'react'
import { UserList, T } from 'components'
import Form from './Form'
import StyledFindDate from './StyledFindDate'

const FindDate = () => {
  const [open, setOpen] = useState(!location.search)

  return (
    <StyledFindDate className={`search-${open ? 'open' : 'closed'}`}>
      <div onClick={() => setOpen(!open)} className="search-toggle">
        <T label="actions/editSearch" />
        <i className="fa fa-angle-up" />
      </div>
      <Form onSubmit={() => setOpen(false)} />
      <UserList pagination placeholders={14} />
    </StyledFindDate>
  )
}

export default FindDate
